import { Link } from "react-router-dom";
import {
  ArrowRight,
  Search,
  Ruler,
  ClipboardCheck,
  HardHat,
  IdCard,
  ShieldCheck,
} from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { IMAGES, PROPERTY_FULL_SERVICE } from "@/data/site";

const ICONS = {
  search: Search,
  ruler: Ruler,
  valuation: ClipboardCheck,
  engineer: HardHat,
  trn: IdCard,
  insurance: ShieldCheck,
};

const PropertyConcierge = () => (
  <section className="relative bg-navy py-24 md:py-32 overflow-hidden" data-testid="property-concierge">
    <img
      src={IMAGES.palm}
      alt=""
      aria-hidden="true"
      className="absolute -right-16 -top-16 w-96 h-96 object-cover opacity-10 saturate-0"
    />
    <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 grid lg:grid-cols-[1fr_1.2fr] gap-14 lg:gap-20 items-center">
      <Reveal>
        <Eyebrow light>For Clients Abroad</Eyebrow>
        <h2 className="font-serif font-light text-cream text-4xl md:text-5xl lg:text-6xl tracking-tight text-balance">
          Buying property in Jamaica? <em className="italic text-gold">We handle it all.</em>
        </h2>
        <p className="text-cream/70 mt-6 text-base md:text-lg leading-relaxed">
          Purchasing from overseas shouldn't mean managing a dozen moving parts
          from a distance. Annwil Law Ja offers a complete, end-to-end service
          for clients abroad — from finding the property to protecting it once
          it's yours.
        </p>
        <Link
          to="/contact"
          data-testid="property-concierge-cta"
          className="group inline-flex items-center gap-3 rounded-full bg-gold text-navy text-sm font-bold px-8 py-4 mt-10 transition-colors duration-300 hover:bg-cream"
        >
          Start Your Property Journey
          <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </Reveal>
      <div className="grid sm:grid-cols-2 gap-px bg-cream/10 border border-cream/10">
        {PROPERTY_FULL_SERVICE.map((item, i) => {
          const Icon = ICONS[item.icon];
          return (
            <Reveal key={item.title} delay={i * 0.07} className="bg-navy">
              <div className="p-7 md:p-8 h-full" data-testid={`concierge-item-${item.icon}`}>
                <Icon size={22} className="text-gold" />
                <h3 className="font-serif text-cream text-xl md:text-2xl mt-4">{item.title}</h3>
                <p className="text-cream/60 text-sm mt-2 leading-relaxed">{item.text}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default PropertyConcierge;
